import React from 'react';
import { Dialog, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const FullscreenContentModal = ({
  open,
  onClose,
  children,
  topContent = null,
  forceLocked = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={forceLocked ? undefined : onClose}
      fullScreen
      disableEscapeKeyDown={forceLocked}
      PaperProps={{
        sx: {
          margin: 0,
          width: '100vw',
          height: '100vh',
          maxWidth: '100vw',
          maxHeight: '100vh',
          backgroundColor: '#000',
        },
      }}
    >
      {/* Top strip for close button (remaining 2-5%) */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '6vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          px: { xs: 1, md: 2 },
        }}
      >
        {/* Close button */}
        {!forceLocked && (
          <IconButton
            onClick={onClose}
            aria-label="Close"
            sx={{
              color: '#fff',
              backgroundColor: 'rgba(0,0,0,0.6)',
              '&:hover': { backgroundColor: 'rgba(255,255,255,0.12)' },
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </Box>

      {/* Remaining viewport under the close strip */}
      <Box
        sx={{
          position: 'absolute',
          top: '6vh',
          left: 0,
          width: '100%',
          height: 'calc(100% - 6vh)',
          overflow: 'hidden',
          backgroundColor: '#000',
        }}
      >
        {children}
      </Box>
    </Dialog>
  );
};

export default FullscreenContentModal;
